import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { FourBoxSquareForm as FourBoxSquareFormBase } from 'cv-library-react-web';

import getStyles from './FourBoxSquareForm.styles';

const FourBoxSquareForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <FourBoxSquareFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

FourBoxSquareForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

FourBoxSquareForm.defaultProps = {
    formElements: [],
};

export default FourBoxSquareForm;
